/**
 * 09/10/2026 — trạng thái xác thực 2 lớp đọc từ claims token (thuần, không side effect — test được không cần OIDC). Chỉ để HIỂN THỊ;
 * gateway SecurityPolicyFilter mới là nơi thi hành.
 */
/** Yếu tố xác thực thứ hai trong claim {@code amr} — khớp gateway SecurityPolicyFilter.MFA_AMR. */
export const MFA_AMR = ['otp', 'mfa', 'hwk', 'sms', 'totp'] as const;

/** Payload JWT (base64url) — chỉ để HIỂN THỊ; chữ ký do máy chủ kiểm. Hỏng → {}. */
export function jwtPayload(token: string | null | undefined): Record<string, unknown> {
  const part = token?.split('.')[1];
  if (!part) return {};
  try {
    const b64 = part
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(Math.ceil(part.length / 4) * 4, '=');
    const json = decodeURIComponent(
      Array.from(atob(b64), (c) => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`).join(''),
    );
    const v = JSON.parse(json) as unknown;
    return v && typeof v === 'object' ? (v as Record<string, unknown>) : {};
  } catch {
    return {};
  }
}

/** 09/10/2026 — trạng thái 2FA từ claims: phiên đã qua yếu tố thứ hai (amr) + tài khoản bị bắt buộc MFA (cờ iam kovix_mfa_required). */
export function mfaStateOf(claims: Record<string, unknown>): { sessionMfa: boolean; required: boolean } {
  const amr = Array.isArray(claims.amr) ? claims.amr.map(String) : [];
  const flag = claims.kovix_mfa_required;
  return {
    sessionMfa: amr.some((a) => (MFA_AMR as readonly string[]).includes(a)),
    required: flag === true || String(flag).toLowerCase() === 'true',
  };
}
